export default __webpack_public_path__ + "static/unity-7e2dd124c04bec7bb172a38fbfe89168.svg";